import { getValueAndUnit } from '../../../../../polished/lib';

export function getNegativeCssValue(value: string) {
    if (!getValueAndUnit(value)[1]) return value;
    return `-${value}`;
}
